<div class="d-flex align-items-center justify-content-between header">
  <h5 class="title">{{data.title}}</h5>
  <mat-icon mat-dialog-close>close</mat-icon>
</div>
<mat-dialog-content>
  <p *ngFor="let item of data.data">{{item}}</p>
</mat-dialog-content>
